// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3aRqb","subheader":"ReorderModal_subheader__1Qfbw","listWrap":"ReorderModal_listWrap__vY6p9"};